import React from "react";
import DegreeCard from "components/degreeCard/DegreeCard";
import { degrees } from "portfolio";
import { FadeIn } from "components/shared/FadeIn";
import SectionHeader from "components/shared/SectionHeader";

function Educations(): React.ReactElement {
  return (
    <section className="mt-16" id="educations">
      <FadeIn duration={800}>
        <SectionHeader
          title="Academic Background"
          description="A focused path from software fundamentals into applied computer science, AI, and production engineering."
        />
      </FadeIn>
      <div className="education-timeline space-y-5">
        {degrees.degrees.map((degree, index) => {
          const key = `${degree.title ?? "degree"}-${index}`;
          return <DegreeCard key={key} degree={degree} />;
        })}
      </div>
    </section>
  );
}

export default Educations;
